<template>
  <ol-vector-layer zIndex="11" :visible="isVisible">
    <ol-source-vector>
      <ol-feature v-for="(sensor, index) in sensorReadings.slice(0, -1)" :key="index">
        <ol-geom-line-string
          :coordinates="[
            [sensorReadings[index].coordinate?.easting, sensorReadings[index].coordinate?.northing],
            [
              sensorReadings[index + 1].coordinate?.easting,
              sensorReadings[index + 1].coordinate?.northing
            ]
          ]"
        ></ol-geom-line-string>
        <ol-style-flowline
          :color="getColor(sensor.doB)"
          :color2="getNextColor(index)"
          :width="strokeWidth"
          :width2="strokeWidth"
          :arrow="0"
          lineCap="round"
        />
      </ol-feature>
    </ol-source-vector>
  </ol-vector-layer>
</template>

<script setup lang="ts">
import { MapCableDataPoint } from '@/server/MakeSenseApp-backend'
import { ref, defineProps, PropType } from 'vue'

const strokeWidth = ref(6)

const props = defineProps({
  sensorReadings: {
    type: Array as PropType<MapCableDataPoint[]>,
    required: true
  },
  isVisible: {
    type: Boolean,
    required: true
  }
})

const colors = ['#5E83C9', '#3E5D97', '#00215F', '#010C21']

const getColor = (dob?: number) => {
  if (dob === undefined) {
    return colors[0]
  }

  if (dob > 0) {
    return colors[0]
  } else if (dob <= 0 && dob > -1) {
    return colors[1]
  } else if (dob <= -1 && dob > -2) {
    return colors[2]
  } else {
    return colors[3]
  }
}

const getNextColor = (index: number) => {
  const sensorReading = props.sensorReadings[index + 1]
  return getColor(sensorReading.doB ?? 0)
}
</script>

<style scoped></style>
